import { whenElementIsInView, loadScript, fire, on } from '../helpers';

let booting = false;

const mapDefaults = {
    mapId: 'bed526aac7e3f65d',
    disableDefaultUI: false,
    mapTypeControl: false,
    mapTypeId: 'roadmap',
    maxZoom: 17,
    minZoom: 6,
    clickableIcons: false,
    streetViewControl: false,
    tilt: 0,
    zoom: 10,
    zoomControl: false,
}

const whenReady = (selector, callback) => {
    let loaded = false;

    whenElementIsInView(selector, inView => {
        if (loaded || !inView) {
            return;
        }

        if (window.googleMapsHasLoaded) {
            callback();
        } else {
            on('google-maps-ready', callback);
        }

        if (!booting) {
            googleMaps();
        }

        loaded = true;
    }, true);
}

export {
    whenReady,
    mapDefaults,
}

window.googleMapsHasLoaded = false;

const googleMaps = () => {
    booting = true;

    window.googleMapsApiReady = () => {
        window.googleMapsHasLoaded = true;
        fire('google-maps-ready')
    }

    return loadScript(
        `https://maps.googleapis.com/maps/api/js?libraries=&v=weekly&key=${process.env.MIX_GOOGLE_API_KEY}&loading=async&callback=googleMapsApiReady`,
    );
}

export default googleMaps
